import {
    CREATE_BROKER_USER_FAILURE,
    CREATE_BROKER_USER_REQUEST,
    CREATE_BROKER_USER_SUCCESS,
    DELETE_BROKER_USER_FAILURE,
    DELETE_BROKER_USER_REQUEST,
    DELETE_BROKER_USER_SUCCESS,
    FETCH_BROKER_USERS_FAILURE,
    FETCH_BROKER_USERS_REQUEST,
    FETCH_FILTER_BROKER_USERS_REQUEST,
    FETCH_BROKER_USERS_SUCCESS,
    UPDATE_BROKER_USER_FAILURE,
    UPDATE_BROKER_USER_REQUEST,
    UPDATE_BROKER_USER_SUCCESS
} from './types';

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const fetchBrokerUsers = (params) => ({
    type: FETCH_BROKER_USERS_REQUEST,
    payload: params
});

export const fetchBrokerUsersFilter = (params) => ({
    type: FETCH_FILTER_BROKER_USERS_REQUEST,
    payload: params
});

export const fetchBrokerUsersSuccess = (data) => ({
    type: FETCH_BROKER_USERS_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function fetchBrokerUsersFailure(error) {
    return {
        type: FETCH_BROKER_USERS_FAILURE,
        error
    };
}

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const createBrokerUser = (params) => ({
    type: CREATE_BROKER_USER_REQUEST,
    payload: params
});

export const createBrokerUserSuccess = (data) => ({
    type: CREATE_BROKER_USER_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function createBrokerUserFailure(error) {
    return {
        type: CREATE_BROKER_USER_FAILURE,
        error
    };
}

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const updateBrokerUser = (params) => ({
    type: UPDATE_BROKER_USER_REQUEST,
    payload: params
});

export const updateBrokerUserSuccess = (data) => ({
    type: UPDATE_BROKER_USER_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function updateBrokerUserFailure(error) {
    return {
        type: UPDATE_BROKER_USER_FAILURE,
        error
    };
}

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const deleteBrokerUser = (params) => ({
    type: DELETE_BROKER_USER_REQUEST,
    payload: params
});

export const deleteBrokerUserSuccess = (data) => ({
    type: DELETE_BROKER_USER_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function deleteBrokerUserFailure(error) {
    return {
        type: DELETE_BROKER_USER_FAILURE,
        error
    };
}
